import React from "react";
const IconMadeInCZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" {...props}>
    <path
      d="M42.0664 16.9541H28.9548V47.9997H42.0664V16.9541Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <path
      d="M28.9541 16.9534C28.9541 16.9534 25.975 14.7736 23.7385 14.6726C21.8432 14.5871 19.0657 15.4846 19.0657 15.4846C19.0657 15.4846 19.9554 25.4966 18.5512 31.3783C16.8534 38.4897 9.93406 47.999 9.93406 47.999H28.9541V16.9534Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <path
      d="M25.4574 14.9905C25.4574 14.9905 26.3471 25.4976 24.9429 31.3793C23.2451 38.4907 16.3258 48 16.3258 48"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path
      d="M40.0295 16.2035C40.0295 13.7076 38.0062 11.6843 35.5104 11.6843C33.0145 11.6843 30.9912 13.7076 30.9912 16.2035"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path d="M35.5098 11.6525L35.5098 8.00005" stroke="currentColor" strokeWidth="2" />
    <path d="M39.6191 23.3525H31.4012" stroke="currentColor" strokeWidth="2" />
    <path d="M39.6191 29.5153H31.4012" stroke="currentColor" strokeWidth="2" />
    <path
      d="M28.9541 29.5153C28.9541 29.5153 26.8139 28.279 25.3247 27.7773C23.125 27.0363 19.4432 26.9204 19.4432 26.9204"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M28.9541 23.3525C28.9541 23.3525 26.7484 21.7383 25.2592 21.2366C23.0595 20.4957 19.4432 20.7577 19.4432 20.7577"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M39.6191 35.6801H31.4012" stroke="currentColor" strokeWidth="2" />
    <path d="M39.6191 41.8427H31.4012" stroke="currentColor" strokeWidth="2" />
    <path
      d="M28.7119 43.297C28.7119 43.297 26.2842 41.641 23.5245 40.9825C20.1209 40.1704 14.3937 40.7681 14.3937 40.7681"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M28.7119 36.4071C28.7119 36.4071 26.2842 34.7512 23.5245 34.0927C21.9038 33.7059 19.7562 33.6389 17.951 33.6748"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
export default IconMadeInCZ;
